import type { DepartmentDTO, HospitalDTO } from '@/generated'

export function convertUserDetailsIntoSimpleObjects(
  details: DepartmentDTO[] | HospitalDTO[]
): { id: string; name: string }[] {
  return details.map((item) => {
    return {
      id: item.id,
      name: item.name
    }
  })
}
